import {create} from 'zustand';

const useReportModal = create((set) => ({
  isOpen: false,
  open: () => set({isOpen: true}),
  close: () => set({isOpen: false}),
}));


export default useReportModal;